import { useState, useContext } from 'react';
import { useHistory } from 'react-router';
import ReactCodeInput from 'react-code-input';
import { Box, Button, Typography, Alert, IconButton, Collapse } from '@mui/material';
import * as JWT from 'jsonwebtoken';

import { AuthContext } from 'context/auth-context';
import { inputstyle } from 'components/authentication/signup/SignupComponent';
import { Login } from 'lib/api';
import { maskEmail } from 'helpers/maskEmail';
import { Set_Name } from 'resolvers/Set_Name';
import CloseIcon from '@mui/icons-material/Close';
import { Token } from 'resolvers/Token';
import ErrorAlert from 'components/shared/ErrorAlert';
import { APP_ROUTES } from 'routes';
import './SecondStepLogin.css';

const SecondStepLogin = ({ previousStep }) => {
    const history = useHistory();
    const [code, setCode] = useState('');
    const [open, setOpen] = useState(false);
    const { preUser, loginUser, setDecodeState } = useContext(AuthContext);
    const [errorMessage, setErrorMessage] = useState('');

    const verifyCode = async e => {
        e.preventDefault();
        try {
            let body = {
                email: preUser.email,
                code
            };
            const response = await Login.verifyCode(body);
            loginUser(response);
            Token(response);
            Set_Name(response);
            const tokenUser = JWT.decode(response.token);
            setDecodeState({
                ...tokenUser,
                loaded: true
            });

            return history.replace(APP_ROUTES.DASHBOARD);
        } catch (error) {
            if (error?.response?.data?.type === 'Auth/ClientCodeNotFound') {
                setErrorMessage('Wrong activation code, request a new one.');
            } else {
                setErrorMessage(error?.response?.data?.message);
            }
        }
    };

    const resendCode = () => {
        Login.loginUser(preUser);
        setOpen(true);
    };

    const disableVerifyButton = () => {
        return !(code.length === 6);
    };

    return (
        <Box display="flex" flexDirection="column">
            <Box
                sx={{
                    fontWeight: 'bold',
                    fontSize: '23px',
                    marginTop: '2em'
                }}>
                Enter Code
            </Box>
            <Box marginTop="1em" marginBottom="16px">
                <Typography variant="subtitle1" className="gray-text">
                    Open the two-factor authentication email we sent to
                    {' ' + maskEmail(preUser.email) + ' '} to view your authentication code.
                </Typography>
            </Box>
            {errorMessage && <ErrorAlert>{errorMessage}</ErrorAlert>}
            <form noValidate onSubmit={e => verifyCode(e)} style={{ marginTop: '40px' }}>
                <Box marginBottom="32px">
                    <ReactCodeInput type="number" fields={6} value={code} inputStyle={inputstyle} onChange={setCode} />
                </Box>

                <Button variant="contained" className="btn-submit btn-rounded" type="submit" disabled={disableVerifyButton()}>
                    Verify and Log In
                </Button>
            </form>
            <Box display="flex" flexDirection="row" justifyContent="center" marginTop="10px">
                <Box className="helper-btn" sx={{ marginRight: '20px' }} onClick={previousStep}>
                    Back
                </Box>
                <Box className="helper-btn" sx={{ marginLeft: '20px' }} onClick={() => resendCode()}>
                    Resend Code
                </Box>
            </Box>
            <Box sx={{ width: '100%' }}>
                <Collapse in={open}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                }}>
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity="success"
                        color="info">
                        Code resent to your email
                    </Alert>
                </Collapse>
            </Box>
        </Box>
    );
};

export default SecondStepLogin;
